import { render, staticRenderFns } from "./EntityEmbedding.vue?vue&type=template&id=9c0b4072&lang=pug&"
import script from "./EntityEmbedding.vue?vue&type=script&lang=js&"
export * from "./EntityEmbedding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports